module.exports = __webpack_public_path__ + "img/cached-logo-farmpay-white.e55cec21.png";